import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { IconButton } from '../../../_shared';
import { messages } from '../../../_shared/i18n/messages';

import './PasswordInput.scss';

const propTypes = {

	/**
	 * The input id. If none is provided, the input name is used.
	 */
	id: PropTypes.string,

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input label.
	 */
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element,
		PropTypes.array,
		PropTypes.shape(),
	]).isRequired,

	/**
	 * The input value.
	 */
	value: PropTypes.string,

	/**
	 * The input placeholder text.
	 */
	placeholder: PropTypes.string,

	/**
	 * The id of the feedback text
	 */
	feedbackID: PropTypes.string,

	/**
	 * True, if editing the input value.
	 */
	isEditing: PropTypes.bool,

	/**
	 * True, if the input value is invalid.
	 */
	isInvalid: PropTypes.bool,

	/**
	 * The input aria-label (if any).
	 */
	ariaLabel: PropTypes.string,

	/**
	 * The autocomplete value of the input
	 */
	autocomplete: PropTypes.string,

	/**
	 * True, if the input value is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Callback function to handle changes to the input value.
	 */
	onChange: PropTypes.func.isRequired,

};

const Input = (props) => {

	const {
		id,
		name,
		label,
		value,
		placeholder,
		feedbackID,
		ariaLabel,
		autocomplete,
		isEditing,
		isInvalid,
		disabled,
		onChange,
	} = props;

	const intl = useIntl();

	const [showPassword, setShowPassword] = useState(false);

	if (!isEditing) {
		console.error('You should not be using "PasswordInput" with isEditing=false...');
		return null;
	}

	return (
		<div
			className={`
				tc-material-input-password-container
				${isInvalid ? 'tc-material-input-wrapper-invalid' : ''}
			`}>
			<input
				id={id || name}
				className={`tc-material-input ${isInvalid ? 'tc-material-input-invalid' : ''}`}
				aria-describedby={isInvalid ? feedbackID : undefined}
				autoComplete={autocomplete}
				type={showPassword ? 'text' : 'password'}
				name={name}
				aria-label={ariaLabel || label}
				value={value}
				placeholder={placeholder}
				disabled={disabled}
				onChange={(event) => onChange(event.target.value)} />
			<IconButton
				id={`${id || name}-show-password-btn`}
				className="tc-show-password-btn"
				icon={showPassword ? 'far fa-eye-slash' : 'far fa-eye'}
				title={
					showPassword
						? intl.formatMessage(messages.TC_COMPONENTS_PASSWORD_INPUT_BUTTON_HIDE_PASSWORD_TEXT)
						: intl.formatMessage(messages.TC_COMPONENTS_PASSWORD_INPUT_BUTTON_SHOW_PASSWORD_TEXT)
				}
				size="26px"
				placement="top"
				tooltip
				onClick={() => setShowPassword((prev) => !prev)} />
		</div>
	);
};

Input.propTypes = propTypes;

export default Input;
